import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Message } from 'primeng/message';

@Component({
  selector: 'app-error-summary',
  standalone: true,
  imports: [Message],
  templateUrl: './error-summary.html',
  styleUrls: ['./error-summary.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorSummary {
  public errors = input<string[]>([]);
}
